import React from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    CircularProgress,
    Card,
    CardContent
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: '#f8f9fa'
}));

const HighLevelPlanEditor = ({
    highLevelPlan,
    setHighLevelPlan,
    isGeneratingPlan,
    handleGeneratePlan,
    handleGenerateReviewFromPlan,
    isGeneratingReview,
    validationError
}) => {
    return (
        <Box>
            {validationError && (
                <Box sx={{ mb: 2 }}>
                    <Typography color="error">{validationError}</Typography>
                </Box>
            )}

            <Card variant="outlined" sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Generate a high-level plan that organizes papers into thematic groups. You can edit this plan before generating the final review.
                    </Typography>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleGeneratePlan}
                        disabled={isGeneratingPlan}
                        sx={{ mr: 2, mt: 1 }}
                    >
                        {isGeneratingPlan ? (
                            <>
                                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                                Generating Plan...
                            </>
                        ) : (
                            'Generate Plan'
                        )}
                    </Button>
                </CardContent>
            </Card>

            {highLevelPlan && (
                <StyledPaper elevation={2}>
                    <Typography variant="subtitle1" gutterBottom>
                        Edit Plan (Organize paper groupings & themes):
                    </Typography>

                    <TextField
                        fullWidth
                        multiline
                        rows={12}
                        value={highLevelPlan}
                        onChange={(e) => setHighLevelPlan(e.target.value)}
                        variant="outlined"
                        margin="normal"
                        placeholder="Your generated plan will appear here. You can edit it before generating the review."
                        InputProps={{
                            sx: {
                                fontFamily: 'monospace',
                                fontSize: '0.9rem',
                                backgroundColor: '#ffffff'
                            }
                        }}
                    />

                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleGenerateReviewFromPlan}
                            disabled={!highLevelPlan || isGeneratingReview}
                        >
                            {isGeneratingReview ? (
                                <>
                                    <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                                    Generating Review...
                                </>
                            ) : (
                                'Generate Review From Plan'
                            )}
                        </Button>
                    </Box>
                </StyledPaper>
            )}
        </Box>
    );
};

export default HighLevelPlanEditor; 